var map = {
	"./az_AZ": 7668,
	"./az_AZ.js": 7668,
	"./config": 4117,
	"./config.js": 4117,
	"./en_US": 8318,
	"./en_US.js": 8318,
	"./ru_RU": 4107,
	"./ru_RU.js": 4107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6267;